import { z } from 'zod';

/**
 * Announcements: staff with the `game.announce` permission broadcast a line
 * to everyone connected, shown as a banner on their screen.
 */
export const ANNOUNCE_MAX_LENGTH = 200;

export const announceClientMessageSchema = z.discriminatedUnion('t', [
  z.object({ t: z.literal('announce:send'), text: z.string().min(1).max(ANNOUNCE_MAX_LENGTH * 2) }),
]);

export const announceServerMessageSchema = z.discriminatedUnion('t', [
  /** Sent on connect to players allowed to announce, so the client knows to accept the command. */
  z.object({ t: z.literal('announce:access'), allowed: z.boolean() }),
  z.object({ t: z.literal('announce:show'), id: z.string(), text: z.string(), from: z.string(), at: z.number() }),
]);

export type AnnounceClientMessage = z.infer<typeof announceClientMessageSchema>;
export type AnnounceServerMessage = z.infer<typeof announceServerMessageSchema>;
